<button class="inline-flex flex-row rounded-[50px] bg-[#E5E8EB] px-2 py-1 text-xs items-center m-1 hover:bg-[#CED0D3]">
  <fa-icon [icon]="faTimes" class="p-0.5 mr-0.5"/>
  <p>
    {{text}}
  </p>
</button>
